import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { getNotificationCount } from '../services/api';


// Custom icons (replacing lucide-react)
const BellIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
  </svg>
);

const UserIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);

const SettingsIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const LogOutIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

const SearchIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
);

const SunIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
  </svg>
);

const MoonIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
  </svg>
);

const AutoIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const BugIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const MessageIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  </svg>
);

const KeyIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
  </svg>
);

const BookIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253z" />
  </svg>
);

// User Avatar Component with caching
const UserAvatar = ({ user, size = 'w-10 h-10' }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  
  const avatarUrl = user?.avatar_url || user?.user_metadata?.avatar_url;
  
  // Reset error state when avatar URL changes
  useEffect(() => {
    setImageError(false);
    setImageLoaded(false);
  }, [avatarUrl]);
  
  // Show profile picture if available and no error occurred
  if (avatarUrl && !imageError) {
    return (
      <img
        src={avatarUrl}
        alt={user?.user_metadata?.full_name || user?.full_name || 'User'}
        className={`${size} rounded-xl object-cover border-2 border-white/20 group-hover:scale-105 transition-transform duration-200 ${!imageLoaded ? 'opacity-0' : 'opacity-100'}`}
        onError={() => {
          setImageError(true);
          setImageLoaded(false);
        }}
        onLoad={() => {
          setImageLoaded(true);
          setImageError(false);
        }}
        loading="lazy"
      />
    );
  }
  
  // Fallback to icon
  return (
    <div className={`${size} bg-gradient-celadon rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-200`}>
      <UserIcon />
    </div>
  );
};

const Header = ({ user, onNotificationUpdate }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const { signOut, user: authUser } = useAuth();
  const { theme, effectiveTheme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  // Use either the passed user prop or the authenticated user from context
  const currentUser = user || authUser;

  // Global search keyboard shortcut
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        navigate('/search');
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);

  const loadNotificationCount = useCallback(async () => {
    if (!currentUser?.id) return;
    
    try {
      const data = await getNotificationCount(currentUser.id, 'collaboration_invite');
      setNotificationCount(data.unread_count);
    } catch (error) {
      console.error('Error loading notification count:', error);
    }
  }, [currentUser?.id]);

  useEffect(() => {
    if (currentUser?.id) {
      loadNotificationCount();
      
      // Set up periodic refresh every 30 seconds instead of on every render
      const interval = setInterval(loadNotificationCount, 30000);
      return () => clearInterval(interval);
    }
  }, [currentUser?.id, loadNotificationCount]);

  // Expose the refresh function to parent components
  useEffect(() => {
    if (onNotificationUpdate && typeof onNotificationUpdate === 'function') {
      onNotificationUpdate(loadNotificationCount);
    }
  }, [onNotificationUpdate, loadNotificationCount]);

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <header className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-xl border-b border-gray-100/50 dark:border-gray-700/50 sticky top-0 z-50">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Banyan Branding - Left Side */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-4 group">
              <div className="relative">
                {/* Animated background circle */}
                <div className="absolute inset-0 bg-gradient-celadon rounded-2xl opacity-20 group-hover:opacity-30 transition-opacity duration-300"></div>
                
                {/* Main logo container */}
                <div className="relative bg-gradient-celadon p-1 rounded-xl shadow-soft group-hover:shadow-medium transition-all duration-300 transform group-hover:scale-105">
                                <img
                                    src="/banyan-icon.jpeg"
                                    alt="Banyan"
                                    className="w-10 h-10 object-contain"
                                />
                            </div>
              </div>
              
              <div className="hidden sm:block">
                <h1 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 dark:from-gray-100 dark:to-gray-300 bg-clip-text text-transparent tracking-tight">
                  Banyan
                </h1>
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400 -mt-1">
                  Grow Smarter Prompts
                </p>
              </div>
            </Link>
          </div>
          
          {/* Center - Search Bar */}
          {currentUser && (
            <div className="hidden lg:flex flex-1 max-w-md mx-8">
              <button
                onClick={() => navigate('/search')}
                className="flex items-center w-full px-4 py-2.5 text-sm text-gray-500 dark:text-gray-400 bg-gray-100/70 dark:bg-gray-800/70 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200 group"
              >
                <SearchIcon className="mr-3 text-gray-400 group-hover:text-gray-600" />
                <span className="flex-1 text-left">Search everything...</span>
                <kbd className="inline-flex items-center px-2 py-1 text-xs font-medium text-gray-600 bg-white/80 rounded border border-gray-200">
                  {navigator.platform.indexOf('Mac') > -1 ? '⌘' : 'Ctrl'} K
                </kbd>
              </button>
            </div>
          )}
          
          {/* Feedback Widgets - Right Side */}
          <div className="flex items-center space-x-3">

            
          {/* User Profile - Right Side */}
            {/* Theme Toggle Button */}
            {/* Disabled dark mode for now*/}
            {/* {currentUser && (
                              <button
                  onClick={toggleTheme}
                  className="p-2.5 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl hover:bg-white dark:hover:bg-gray-800 hover:shadow-soft transition-all duration-300 border border-gray-100/50 dark:border-gray-700/50 group text-gray-600 dark:text-gray-400"
                  title={`Switch to ${effectiveTheme === 'light' ? 'dark' : 'light'} mode`}
                >
                {effectiveTheme === 'light' ? (
                  <MoonIcon />
                ) : (
                  <SunIcon />
                )}
              </button>
            )} */}
            
            {currentUser ? (
              <div className="relative">
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="flex items-center space-x-3 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl px-5 py-3 hover:bg-white dark:hover:bg-gray-800 hover:shadow-soft transition-all duration-300 border border-gray-100/50 dark:border-gray-700/50 group"
                >
                  {/* User Avatar */}
                  <div className="relative">
                    <UserAvatar user={currentUser} />
                    
                    {/* Notification indicator */}
                    {notificationCount > 0 && (
                      <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium shadow-soft animate-pulse">
                        {notificationCount > 9 ? '9+' : notificationCount}
                      </div>
                    )}
                  </div>
                  
                  {/* User Info */}
                  <div className="hidden md:block text-left">
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 group-hover:text-gray-800 dark:group-hover:text-gray-200 transition-colors">
                      {currentUser.user_metadata?.full_name || currentUser.full_name || 'User'}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400 -mt-0.5">
                      {currentUser.email}
                    </p>
                  </div>
                  
                  {/* Dropdown indicator */}
                  <div className="transform group-hover:rotate-180 transition-transform duration-200">
                    <ChevronDownIcon />
                  </div>
                </button>
                
                {dropdownOpen && (
                  <div className="absolute right-0 mt-3 w-72 bg-white/95 dark:bg-gray-800/95 backdrop-blur-xl rounded-2xl shadow-strong py-2 z-50 border border-gray-100/50 dark:border-gray-700/50 animate-scale-in">
                    {/* User Info Header */}
                    <div className="px-5 py-4 border-b border-gray-100/50 dark:border-gray-700/50">
                      <div className="flex items-center space-x-3">
                        <UserAvatar user={currentUser} size="w-12 h-12" />
                        <div>
                          <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                            {currentUser.user_metadata?.full_name || currentUser.full_name || 'User'}
                          </p>
                          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                            {currentUser.email}
                          </p>
                          {/* Show provider info if signed in with Google */}
                          {currentUser.app_metadata?.provider === 'google' && (
                            <div className="flex items-center mt-1">
                              <svg className="w-3 h-3 mr-1" viewBox="0 0 24 24">
                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                              </svg>
                              <span className="text-xs text-gray-400 dark:text-gray-500">Signed in with Google</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    
                    {/* Dropdown Items */}
                    <div className="py-2">
                      <Link
                        to="/notifications"
                        onClick={() => setDropdownOpen(false)}
                        className="flex items-center w-full px-5 py-3 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50/80 dark:hover:bg-gray-700/50 transition-colors group"
                      >
                        <div className="w-8 h-8 bg-celadon-50 dark:bg-celadon-900/30 rounded-lg flex items-center justify-center mr-3 group-hover:bg-celadon-100 dark:group-hover:bg-celadon-800/50 transition-colors">
                          <BellIcon />
                        </div>
                        <span className="flex-1">Notifications</span>
                        {notificationCount > 0 && (
                          <span className="bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">
                            {notificationCount > 9 ? '9+' : notificationCount}
                          </span>
                        )}
                      </Link>
                      
                      <Link
                        to="/api-keys"
                        onClick={() => setDropdownOpen(false)}
                        className="flex items-center w-full px-5 py-3 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50/80 dark:hover:bg-gray-700/50 transition-colors group"
                      >
                        <div className="w-8 h-8 bg-blue-50 dark:bg-blue-900/30 rounded-lg flex items-center justify-center mr-3 group-hover:bg-blue-100 dark:group-hover:bg-blue-800/50 transition-colors">
                          <KeyIcon />
                        </div>
                        <span className="flex-1">API Keys</span>
                      </Link>
                      
                      <Link
                        to="/settings"
                        onClick={() => setDropdownOpen(false)}
                        className="flex items-center w-full px-5 py-3 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50/80 dark:hover:bg-gray-700/50 transition-colors group"
                      >
                        <div className="w-8 h-8 bg-gray-50 dark:bg-gray-700/50 rounded-lg flex items-center justify-center mr-3 group-hover:bg-gray-100 dark:group-hover:bg-gray-600/50 transition-colors">
                          <SettingsIcon />
                        </div>
                        <span className="flex-1">Settings</span>
                      </Link>

                      <a
                        href="https://www.usebanyan.com/docs"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setDropdownOpen(false)}
                        className="flex items-center w-full px-5 py-3 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50/80 dark:hover:bg-gray-700/50 transition-colors group"
                      >
                        <div className="w-8 h-8 bg-indigo-50 dark:bg-indigo-900/30 rounded-lg flex items-center justify-center mr-3 group-hover:bg-indigo-100 dark:group-hover:bg-indigo-800/50 transition-colors">
                          <BookIcon />
                        </div>
                        <span className="flex-1">Help & Documentation</span>
                        <svg className="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      </a>
                    </div>
                    
                    {/* Sign Out */}
                    <div className="border-t border-gray-100/50 dark:border-gray-700/50 pt-2">
                      <button
                        onClick={handleSignOut}
                        className="flex items-center w-full px-5 py-3 text-sm text-gray-700 dark:text-gray-300 hover:bg-red-50/80 dark:hover:bg-red-900/20 hover:text-red-600 dark:hover:text-red-400 transition-colors group"
                      >
                        <div className="w-8 h-8 bg-gray-50 dark:bg-gray-700/50 rounded-lg flex items-center justify-center mr-3 group-hover:bg-red-100 dark:group-hover:bg-red-800/30 transition-colors">
                          <LogOutIcon />
                        </div>
                        <span>Sign out</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex items-center space-x-3">
                <Link
                  to="/login"
                  className="btn-ghost btn-sm"
                >
                  Sign in
                </Link>
                <Link
                  to="/register"
                  className="btn-primary btn-sm"
                >
                  Sign up
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Close dropdown when clicking outside */}
      {dropdownOpen && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setDropdownOpen(false)}
        />
      )}
      

    </header>
  );
};

export default Header; 